module.exports = __webpack_public_path__ + "static/media/Lindsey Malcolm.ab61fe15.png";